function hideTitleAndSetAspectRatio() {
    var images = document.querySelectorAll('img');
    images.forEach(function(img) {
        if (img.alt.includes("- Removable Patch -") || img.alt.includes("- Patch - Pull Patch -")) {
            var figure = img.closest('.productitem--image');
            if (!figure) {
                figure = img.closest('.productitem--image-primary');
            }
            var parent = img.closest('.productitem');
            var titleElement = null;
            if (parent !== null) {
                titleElement = parent.querySelector('.productitem--title');
            } else {
                console.log('Parent element not found.');
            }
            if (figure) {
                console.log('mobilleeeee   ');
                setTimeout(() => {
                    const sliderHolder = figure.closest('.flickity-viewport');
                    if (sliderHolder) {
                        setTimeout(() => {
                            sliderHolder.classList.add('flickity-viewport--removable-patch');
                        }, 400);
                    }
                },400);
                figure.style.aspectRatio = '13 / 9';
                parent.classList.add('productitem--removable-patch');
                titleElement.classList.add('productitem--removable-patch--title');
                titleElement.innerHTML = '';
                parent.closest(".productgrid--item").classList.add('productgrid--item--removable-patch');
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    function checkFlickityActivation() {
        if (window.flickityActivated) {
            console.log('Flickity is activated');
            hideTitleAndSetAspectRatio();
            clearInterval(intervalId);
        } else {
        console.log('Flickity is not yet activated, checking again...');
        }
    }
    let intervalId = setInterval(checkFlickityActivation, 200);
    hideTitleAndSetAspectRatio();
});

  
// function adjustCanvasSize() {
//     const canvases = document.querySelectorAll('.pplr .pplr_preview_wrapper canvas');
  
//     canvases.forEach(canvas => {
//       const aspectRatio = 13 / 11;
  
//       const width = canvas.parentElement.offsetWidth;
//       canvas.style.width = width + 'px';
  
//       const height = width / aspectRatio;
//       canvas.style.height = height + 'px';
//     });
//   }
  
//   adjustCanvasSize();
//   window.addEventListener('resize', adjustCanvasSize);



// In your theme.liquid or slider initialization code
document.addEventListener('DOMContentLoaded', function() {
  const fixSliderHeight = () => {
    const slider = document.querySelector('[data-subcollections-layout="slideshow"]');
    if (slider) {
      slider.style.height = '';
      if (typeof Flickity !== 'undefined') {
        Flickity.data(slider)?.resize();
      }
    }
  };
  
  // Run on load and whenever images load
  window.addEventListener('load', fixSliderHeight);
  document.addEventListener('lazyloaded', fixSliderHeight);
});